// RoomObject.jsx
// A single clickable room hotspot (mirror/book/tablet/safe/chest), positioned
// as a percentage box over the room scene image — see games/escape-to-inner-peace/
// data/roomObjects.js for where each percentage comes from. Phase 3: a
// locked object isn't rendered at all, matching room.php's
// `$mapHotspot('0X').css("display","none")` for objects 2-5 until the
// previous stage completes. A completed object stays hidden too (its
// hotspot is spent, same as PHP disabling pointer-events after success).
import React from 'react';
import './RoomObject.css';

function RoomObject({ id, label, image, left, top, width, height, onClick, testId, locked, completed }) {
  if (locked || completed) return null;

  return (
    <button
      type="button"
      className="escape-room-object"
      style={{ left: `${left}%`, top: `${top}%`, width: `${width}%`, height: `${height}%` }}
      onClick={() => onClick(id)}
      aria-label={label}
      data-testid={testId}
    >
      <img src={image} alt="" className="escape-room-object-img" draggable={false} />
    </button>
  );
}

export default RoomObject;
